import { PopoverButton } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

export default function NavbarMobileMenuButton() {
    return (
        <PopoverButton className='md:hidden -mr-2 group relative inline-flex items-center justify-center rounded-md bg-transparent p-1.5 text-white hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white'>
            <span className='absolute -inset-0.5' />
            <span className='sr-only'>Open main menu</span>
            <Bars3Icon aria-hidden='true' className='block size-6 group-data-[open]:hidden' />
            <XMarkIcon aria-hidden='true' className='hidden size-6 group-data-[open]:block' />
        </PopoverButton>
    );
}
